import { useSelector } from 'react-redux';

import {
  selectOptionsBreakdown,
  selectSelectedOptionsTotal,
  selectTotalPrice,
} from 'src/redux/basket/selectors';
import { selectIsPersonalisable, selectProductPrice } from 'src/redux/product/selectors';
import type { PriceBreakdownStateProps } from './PriceBreakdown';

export const usePriceBreakdown = (): PriceBreakdownStateProps => {
  const personalisable = useSelector(selectIsPersonalisable);
  const productPrice = useSelector(selectProductPrice);
  const totalPrice = useSelector(selectTotalPrice);
  const optionsTotal = useSelector(selectSelectedOptionsTotal);
  const priceBreakdown = useSelector(selectOptionsBreakdown);

  return { optionsTotal, personalisable, priceBreakdown, productPrice, totalPrice };
};
